<template>
  <div v-if="content.show" class="field" :class="content.errorMessage?'errorBorder':''">
    <p class="text">
      <span>{{content.order}}</span>{{content.title}}
    </p>
    <div class="ui-controlgroup">
      <div class="ui-checkbox"  v-for="(item,index) in content.options" @click="selectCurrent(index,content.num,content.type)">
        <span class="jqcheckwrapper">
           <a class="jqcheck" :class="selected[index]?'jqchecked':''" href="javascript:;"></a>
         </span>
        <div class="label">{{item}}</div>
      </div>
    </div>
    <div class="errorMessage">{{content.errorMessage}}</div>
  </div>
</template>
<script>
export default {
  props:{
    content: Object
  },
  data() {
    return {
      selected:[false, false, false, false, false, false, false, false, false, false, false, false, false]
    }
  },
  methods:{
    selectCurrent(i,num,type) {
      let self = this,value = self.selected
      if(this.content.limit){
         let arr = self.selected.filter((item)=>{return item==true})
         if(value[i]){
           self.$set(self.selected,i,false)
         }
         if(arr.length<this.content.limit){
          self.$set(self.selected,i,true)
         }else{

         }
         self.$emit('listenToChildEvent',i+1,num,type)
      }else{
        if(value[i]){
          self.$set(self.selected,i,false)
        }else{
          self.$set(self.selected,i,true)
        }
        self.$emit('listenToChildEvent',i+1,num,type)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  p
    max-width:12rem;
  .ui-controlgroup
    width:96%
    margin:auto
  .ui-checkbox
    background: none repeat scroll 0 0 #fff;
    border-bottom: 1px solid #d5d5d5;
    font-size: 16px;
    min-height: 43px;
    position: relative;
    overflow:hidden;
    .label
      display: block;
      margin-left: 40px;
      padding: 12px 10px 10px 0;
      cursor: pointer;
     .jqcheckwrapper
        display: block;
        float: left;
        margin: 11px 4px 10px 11px;
        .jqcheck
          background-color: #fafafa;
          border: 1px solid #cacece;
          padding: 9px;
          border-radius: 3px;
          display: inline-block;
          position: relative;
        a.jqchecked
          background-color: #53a4f4!important;
          background: url(/images/checkedbox.png) no-repeat scroll center top transparent;
          background-size: cover;
          height:3px;
          vertical-align: middle;
          width: 3px;
          border: none;
</style>
